export default {
  data() {
    return {
      button: document.querySelector(
        ".headerMain-item.headerMain-item--mobile-top .headerMain-btn"
      ),
      legacy: document.querySelector("#legacyApplyEndpointURL"),
      original: document.querySelector("#applyEndpointURL")
    };
  },
  methods: {
    init_apply() {
      if (this.button) {
        this.original = document.querySelector("#applyEndpointURL").value;
        this.button.classList.add("next_gen-control");
      }
    },
    set_apply(legacy) {
      if (this.button) {
        if (legacy) {
          this.button.setAttribute("href", this.legacy.value);
        } else {
          this.button.setAttribute("href", this.original.value);
        }
      }
    },
    hide_apply() {
      if (this.button) {
        this.button.classList.add("next_gen-control--hidden");
      }
    },
    show_apply() {
      if (this.button) {
        this.button.classList.remove("next_gen-control--hidden");
      }
    }
  }
};
